<template>
    <section>
        <div class="d-flex justify-content-center">
            <h3>Denuncia efetuada com sucesso</h3>
        </div>

        <div class="d-flex justify-content-center mt-5">
            <h5>Protocolo</h5>
        </div>

        <div class="d-flex justify-content-center mb-5">
            <h1>{{ protocolo }}</h1>
        </div>

        <div class="row">
            <ul>
                <li>Anote o número de seu protocolo.</li>
                <li>O protocolo é sua identificação a esta denúncia.</li>
                <li>Somente com o número de protocolo é possível acompanhar o andamento de sua denúncia ou efetuar complementos a ela.</li>
            </ul>
        </div>

        <hr>

        <div class="d-flex justify-content-end">
            <button @click="print" class="btn btn-sm btn-light ml-2">Imprimir</button>
            <router-link :to="{ name: 'den_index' }" class="btn btn-sm btn-light ml-2">Voltar</router-link>
        </div>
    </section>
</template>

<script>
export default {
    name: "Denuncia-Protocolo",
    // props: [ 'protocolo' ],

    computed: {
        protocolo() {
            return this.$route.params.protocolo
        }
    },

    methods: {
        print() {
            window.print()
        }
    }
}
</script>

<style>

</style>